import { fontWeightOptions } from "./constants/fontWeightOptions";

export * from "./Typography";
export { fontWeightOptions };
